export const overview = {
  impressions: 1006103,
  clicks: 2139,
  ctr: 0.21,
  videoCompletion: 60.02,
  completedViews: 22645,
};

export const channels = [
  { channel: "Static Display", impressions: 966107, clicks: 2091, ctr: 0.22, completedViews: null, completionRate: null },
  { channel: "Video", impressions: 39996, clicks: 48, ctr: 0.12, completedViews: 22645, completionRate: 60.02 },
];

export const campaigns = [
  { id: 1, tactic: "Geotargeting", format: "Static", impressions: 312066, clicks: 655, ctr: 0.21 },
  { id: 2, tactic: "Geotargeting", format: "Static", impressions: 269144, clicks: 511, ctr: 0.19 },
  { id: 3, tactic: "Geotargeting", format: "Static", impressions: 147397, clicks: 354, ctr: 0.24 },
  { id: 4, tactic: "Geotargeting", format: "Static", impressions: 85834, clicks: 180, ctr: 0.21 },
  { id: 5, tactic: "Geotargeting", format: "Static", impressions: 62452, clicks: 144, ctr: 0.23 },
  { id: 6, tactic: "Addressable Geofencing", format: "Static", impressions: 62365, clicks: 162, ctr: 0.26 },
  { id: 7, tactic: "Geotargeting", format: "Video", impressions: 19999, clicks: 22, ctr: 0.11 },
  { id: 8, tactic: "Geotargeting", format: "Video", impressions: 19997, clicks: 26, ctr: 0.13 },
  { id: 9, tactic: "Addressable Geofencing", format: "Static", impressions: 7764, clicks: 21, ctr: 0.27 },
  { id: 10, tactic: "Event Retargeting", format: "Static", impressions: 4938, clicks: 14, ctr: 0.28 },
  { id: 11, tactic: "Geofencing", format: "Static", impressions: 4064, clicks: 13, ctr: 0.32 },
  { id: 12, tactic: "Geofencing", format: "Static", impressions: 3132, clicks: 10, ctr: 0.32 },
  { id: 13, tactic: "Site Retargeting", format: "Static", impressions: 3086, clicks: 10, ctr: 0.32 },
  { id: 14, tactic: "Site Retargeting", format: "Static", impressions: 2818, clicks: 10, ctr: 0.35 },
  { id: 15, tactic: "Site Retargeting", format: "Static", impressions: 1047, clicks: 7, ctr: 0.67 },
];

export const tactics = ["All", "Geotargeting", "Addressable Geofencing", "Event Retargeting", "Geofencing", "Site Retargeting"];

export const markets = [
  { market: "Primary Market", impressions: 950000, clicks: 1980, ctr: 0.21 },
  { market: "Metro Area 1", impressions: 10538, clicks: 32, ctr: 0.3 },
  { market: "Other Markets", impressions: 44344, clicks: 118, ctr: 0.27 },
  { market: "Metro Area 2", impressions: 259, clicks: 2, ctr: 0.77 },
  { market: "Metro Area 3", impressions: 207, clicks: 1, ctr: 0.48 },
  { market: "Regional Area 1", impressions: 186, clicks: 2, ctr: 1.08 },
  { market: "Regional Area 2", impressions: 173, clicks: 1, ctr: 0.58 },
  { market: "Regional Area 3", impressions: 149, clicks: 1, ctr: 0.67 },
  { market: "Regional Area 4", impressions: 146, clicks: 1, ctr: 0.68 },
  { market: "Regional Area 5", impressions: 101, clicks: 1, ctr: 0.99 },
];

export const highlights = [
  { title: "Strong Reach", desc: "More than one million impressions demonstrate scalable delivery across static and video placements." },
  { title: "Engaged Traffic", desc: "Ad-set-level CTR lets performance be compared at a glance — from broad geotargeting to precision retargeting." },
  { title: "Layered Tactics", desc: "Geotargeting, addressable geofencing, event and site retargeting working together in one coordinated program." },
];
